import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core'

import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { MessageService, SortEvent } from 'primeng/api'

import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from 'src/app/carefinity/directives/customsort'
import { DataPageOfVital, UiPreferences, Vital } from '../../../../../api/models'
import {
    VitalService,
    ColumnChooserService,
    AppSettingService,
} from '../../../../../api/services'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
    selector: 'app-vital-list',
    templateUrl: './vital-list.component.html',
    styleUrls: ['./vital-list.component.css'],
})
export class VitalListComponent implements OnInit {
    Item = 'Vitals'
    clinical: string = ''
    vitals: DataPageOfVital
    selectedPatient: Vital
    Lastpageindex: number = 1
    rows: number
    _selectedColumns: any[]
    showRecords: boolean = false

    graphdata: any
    popupheader: string = ''
    private cols: any[]
    othercol: any[]
    FlagHeight: string = 'Cm'
    FlagWeight: string = 'Kg'

    FlagTemp: string = 'F';
    basicOptions: any
    displaypopup: boolean = false
    displaychartstypepopup: boolean = false

    growthcharttype: string = ''

    displayGrowthChartPopUp: boolean = false

    chartType: number = 0

    imageData: string

    growthChartPopUp: boolean = false
    patientGender: boolean = false
    genderName: string = ''
    isButtonDisabled: boolean = true // Initially enabled

    imageWidth: string = '50%'
    zoomInOutLable: string = 'Zoom In'
    zoomInOutIcon: string = 'pi pi-window-maximize'

    growthChartLabelDetails: string = ''
    patientFullName
    showPatientDemographicPrint: boolean = false;
    pageSize: number = 0;

    preferences: UiPreferences = {};
    setPrintFlag: boolean = false;

    istooglebtnClicked: boolean = false;

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private vstservice: VitalService,
        private columnchooserservice: ColumnChooserService,
        private route: ActivatedRoute,
        private datePipe: DatePipe,
        private _spinnerService: NgxSpinnerService,
        private cstsort: Customsort,
        private appSetting: AppSettingService,
        private messageService: MessageService
    ) { }

    ngOnInit() {

        this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;

        this.FlagTemp = CareFinitySession?.practiceSettings.chartUnit.toString();

        //alert(this.FlagTemp);

        this.cols = [
            { field: 'shortVitalDate', header: 'Date' },
            { field: 'height', header: 'Height' },
            { field: 'weight', header: 'Weight' },
            { field: 'bmi', header: 'BMI' },
            { field: 'bp', header: 'BP' },
            { field: 'pulse', header: 'Pulse' },
            { field: 'temp', header: 'Temp' },
            { field: 'resp', header: 'Resps' },
            { field: 'spo2', header: 'SpO2' },
            { field: 'headCirc', header: 'Head Circ' },
        ]
        this.patientFullName = sessionStorage.getItem('ptName');
        this.vitalList(1, 'Desc', 'No')

        this.appSetting
            .appSettingGetPracticeSettings$Response()
            .subscribe((res) => {
                this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;

                if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
                    this.setPrintFlag = true;
                }
                else {
                    this.setPrintFlag = false;
                }
            })

        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.vitals || 'Vitals';
        }
    }

    @Input() get selectedColumns(): any[] {
        // console.log(this._selectedColumns);
        return this._selectedColumns
    }

    set selectedColumns(val: any[]) {
        let selectedValues = [...val]

        if (selectedValues.length == 0) {
            selectedValues = this._selectedColumns = [this.cols[0]]
        } else {
            //restore original order

            this._selectedColumns = val
        }

        let filteredData = Array.prototype.map
            .call(selectedValues, (s) => s.field)
            .toString()
        let filteredValue = Array.prototype.map
            .call(selectedValues, (s) => s.header)
            .toString()

        this.columnchooserservice
            .columnChooserColumnchooser({
                columnNames: filteredData,
                columnValue: filteredValue,
                type: 'Vital',
            })
            .subscribe((result) => { })
    }
    customSort(event: SortEvent, num: number) {
        this.vitals.data = this.cstsort.generalcustomSort(event, this.vitals.data)
    }
    vitalList(pageNumber: number, sortbydirection: string, togleunit: string) {
        this.vstservice
            .vitalList({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                mrn: localStorage.getItem('mrn'),
                pageNumber: pageNumber,
                sortbydirection: sortbydirection,
                Toggle: togleunit,
            })
            .subscribe((result) => {
                console.log(result)

                this.vitals = result

                this.vitals.data = result.data.map((i) => ({ ...i, ...i.otherColumns }))

                this.rows = this.vitals.pageSize

                console.log(result)

                if (this.vitals.totalRecords > 0) {
                    this.showRecords = true
                } else {
                    this.showRecords = false
                }

                if (this.vitals.data.length > 0) {
                    this.FlagHeight = this.vitals.data[0].flagHeight;
                    this.FlagWeight = this.vitals.data[0].flagWeight;

                }
                //Find index of specific object using findIndex method.
                let heightIndex = this.cols.findIndex((obj) => obj.field == 'height');
                let weightIndex = this.cols.findIndex((obj) => obj.field == 'weight');
                let tempIndex = this.cols.findIndex((obj) => obj.field == 'temp');

                //Update object's name property.
                this.cols[heightIndex].header = 'Height' + '(' + this.FlagHeight + ')'
                this.cols[weightIndex].header = 'Weight' + '(' + this.FlagWeight + ')'



                let unit = this.FlagTemp === '0' ? 'F' : 'C';
                // only override when user has actually toggled (istogglclic === true)
                if (this.istooglebtnClicked && typeof togleunit === 'string' && togleunit.trim() !== '') {
                    // assuming "yes" => F, "no" => C
                    if (this.FlagHeight == 'in') {
                        unit = 'F';
                    }
                    else {
                        unit = 'C';
                    }

                }

                // set header once using the final unit
                this.cols[tempIndex].header = `Temp (${unit})`;



                let addedFields = new Set(this.cols.map((col) => col.field))

                for (var key in this.vitals.data[0].otherColumns) {
                    if (this.vitals.data[0].otherColumns.hasOwnProperty(key)) {
                        // Check if key is already in addedFields set
                        if (!addedFields.has(key)) {
                            // Add to addedFields set
                            addedFields.add(key)

                            // Push to this.cols
                            this.cols.push({ field: key, header: key })
                        }
                    }
                }
                if (
                    this.vitals.data[0].savedColumns != null &&
                    this.vitals.data[0].savedColumns.length > 0
                ) {
                    var Savednames = this.vitals.data[0].savedColumns.split(',')
                    this._selectedColumns = this.cols.filter((col) =>
                        Savednames.includes(col.field),
                    )
                } else {
                    this._selectedColumns = this.cols
                }
            },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err?.error,
                        life: 3000,
                    })
                },
            )
        console.log('Vitals')
        console.log(this.vitals)
    }
    toggleActivation($event) {
        if ($event.checked) {
            this.istooglebtnClicked = true;
            this.vitalList(1, '', 'YES')
        } else {
            this.istooglebtnClicked = true;
            this.vitalList(1, '', 'NO')
        }
    }

    //calculateBMI(obj): number {
    //    if (obj == undefined || obj == null) {
    //        return 0.0
    //    }
    //    let Weight: number = obj.weight,
    //        height: number = obj.height,
    //        chartUnit: string = 'metric'

    //    if (
    //        obj.flagHeight.toUpperCase() == 'IN' &&
    //        obj.flagWeight.toUpperCase() == 'LBS'
    //    ) {
    //        chartUnit = 'English'
    //    }

    //    let BMI: number = 0
    //    if (Weight <= 0 || height <= 0) {
    //        return BMI
    //    }

    //    switch (chartUnit.toUpperCase()) {
    //        case 'ENGLISH':
    //            BMI = (Weight / height / height) * 703
    //            break
    //        case 'METRIC':
    //            height = height / 100
    //            BMI = (Weight / height / height) * 10000
    //            break
    //    }

    //    return <number>Math.round(BMI)
    //}

    calculateBMI(obj: any): number | null {
        if (!obj) return null;

        const weight = Number(obj.weight);
        const height = Number(obj.height);

        if (!weight || !height || weight <= 0 || height <= 0) {
            return null; // Invalid input, don't calculate
        }

        const chartUnit = (obj.flagHeight?.toUpperCase() === 'IN' && obj.flagWeight?.toUpperCase() === 'LBS')
            ? 'ENGLISH'
            : 'METRIC';

        let bmi: number;

        switch (chartUnit) {
            case 'ENGLISH':
                bmi = (weight / (height * height)) * 703;
                break;
            case 'METRIC':
                const heightInMeters = height / 100;
                bmi = weight / (heightInMeters * heightInMeters);
                break;
            default:
                return null; // Unknown unit
        }

        return Math.round(bmi);
    }

    setSelection(item) {
        this.displaychartstypepopup = true;
        if (this.clinical == item) {
            // If the clicked button is already selected, uncheck it

            this.clinical = '';
        } else {
            // Otherwise, select the clicked button

            this.clinical = item;
        }
        this.getgraphDetails(item)
        // alert(item);
    }
    getgraphDetails(item) {
        this.resetSelection();
        this.popupheader = item

        if (item.toUpperCase().indexOf('BP') > -1) {
            item = 'Systolic'
        }

        this.displaypopup = true
        this.vstservice.vitalGetGraphForVital({
            PatientId: sessionStorage.getItem('ptId'),
            emrpracticeId: localStorage.getItem('EmrPracticeId'),
            vitalname: item,
        })
            .subscribe((result) => {
                console.log('result is ', result)

                if (item == 'Systolic') {
                    var str = result.graphList?.map((y) => y.graphValue)
                    const sytolic: string[] = []
                    const diasystolic: string[] = []
                    for (let i = 0; i < str.length; i++) {
                        var newstr = str[i].toString().split('/')
                        sytolic.push(newstr[0])
                        diasystolic.push(newstr[1])
                    }
                    sytolic.join(',')
                    diasystolic.join(',')
                    this.graphdata = {
                        labels: result.graphList?.map((y) => y.shortVitalDate),
                        datasets: [
                            {
                                label: item,
                                data: sytolic,
                                fill: false,
                                borderColor: '#42A5F5',
                            },
                            {
                                label: 'Diastolic',
                                data: diasystolic,
                                fill: false,
                                borderColor: '#FFA726',
                            },
                        ],
                    }
                } else {
                    this.graphdata = {
                        labels: result.graphList?.map((y) => y.shortVitalDate),
                        datasets: [
                            {
                                label: item,
                                data: result.graphList?.map((y) => y.graphValue),
                                fill: false,
                                borderColor: '#42A5F5',
                            },
                        ],
                    }
                }
            })
    }

    showGrowthCharts() {



        if (sessionStorage.getItem('patientGender').toLowerCase() == 'male') {
            this.patientGender = true
            this.genderName = 'Male'
        } else {
            this.patientGender = false
            this.genderName = 'Female'
        }
        this.displayGrowthChartPopUp = true
    }

    setGrowthchartType(chartTypeLabel: any) {
        switch (chartTypeLabel) {
            case 'G_3': {
                this.growthChartLabelDetails =
                    '2 to 20 years: Girls, Stature-for-age and Weight-for-age percentiles'
                break
            }
            case 'G_4': {
                this.growthChartLabelDetails =
                    '2 to 20 years: Girls, Body mass index-for-age percentiles'
                break
            }
            case 'G_5': {
                this.growthChartLabelDetails = 'Weight-for-stature percentiles: Girls'
                break
            }
            case 'G_1': {
                this.growthChartLabelDetails =
                    'Birth to 36 months: Girls, Length-for-age and Weight-for-age percentiles'
                break
            }
            case 'G_2': {
                this.growthChartLabelDetails =
                    'Birth to 36 months: Girls, Head circumference-for-age and Weight-for-length percentiles'
                break
            }

            case 'B_3': {
                this.growthChartLabelDetails =
                    '2 to 20 years: Boys, Stature-for-age and Weight-for-age percentiles'
                break
            }
            case 'B_4': {
                this.growthChartLabelDetails =
                    '2 to 20 years: Boys, Body mass index-for-age percentiles'
                break
            }
            case 'B_5': {
                this.growthChartLabelDetails = 'Weight-for-stature percentiles: Boys'
                break
            }
            case 'B_1': {
                this.growthChartLabelDetails =
                    'Birth to 36 months: Boys, Length-for-age and Weight-for-age percentiles'
                break
            }
            case 'B_2': {
                this.growthChartLabelDetails =
                    'Birth to 36 months: Boys, Head circumference-for-age and Weight-for-length percentiles'
                break
            }
        }

        this.chartType = Number(this.growthcharttype.replace(/\D/g, ''))

        //console.log(this.chartType);

        this.isButtonDisabled = false
    }

    createGrowthchartType() {
        this.displayGrowthChartPopUp = false
        this.vstservice
            .vitalGetGrowthChart({
                practiceId: localStorage.getItem('EmrPracticeId'),
                patientId: sessionStorage.getItem('ptId'),
                chartType: this.chartType,
            })
            .subscribe((result) => {
                console.log(result)
                this.imageData = URL.createObjectURL(result)
                this.growthChartPopUp = true
            })

        this.growthcharttype = ''
        this.isButtonDisabled = true
    }

    zoomGrowthChart() {
        if (this.imageWidth == '50%') {
            this.imageWidth = '100%'
            this.zoomInOutIcon = 'pi pi-window-minimize'
            this.zoomInOutLable = 'Zoom Out'
        } else {
            this.imageWidth = '50%'
            this.zoomInOutIcon = 'pi pi-window-maximize'
            this.zoomInOutLable = 'Zoom In'
        }
    }

    printGrowthChart() {
        var PrintGrowthChart = document.getElementById(
            'printGrowthChart',
        ) as HTMLElement
        const printWindow = window.open('', '_blank')
        //const printWindow = window.open('', 'printdiv');
        if (printWindow) {
            const divContent = PrintGrowthChart.innerHTML
            printWindow.document.open()
            printWindow.document.write(
                '<html><head><title>Print::GrowthChart</title>',
            )
            // Adding CSS styling for alternate rows
            printWindow.document.write('<style type="text/css">')
            printWindow.document.write(
                '    #appointment_print_table_tbody tbody tr:nth-child(odd) {',
            )
            printWindow.document.write('        background-color: #f2f2f2;')
            printWindow.document.write('    }')
            printWindow.document.write(
                '    #appointment_print_table_tbody tbody tr:nth-child(even) {',
            )
            printWindow.document.write('        background-color: #e6e6e6;')
            printWindow.document.write('    }')
            printWindow.document.write('</style>')
            printWindow.document.write('</head><body>')
            printWindow.document.write(divContent)
            printWindow.document.write('</body><html>')
            printWindow.document.close()
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        } else {
            console.error('Failed to open print window.')
        }
    }

    printVitals() {
        var PrintVitals = document.getElementById('PrintVitals_List') as HTMLElement
        const printWindow = window.open('', '_blank')
        if (printWindow) {
            const divContent = PrintVitals.innerHTML
            printWindow.document.open()
            printWindow.document.write(
                '<html><head><title>Print::Vitals List</title>',
            )
            // Adding CSS styling for alternate rows
            printWindow.document.write('<style type="text/css">')
            printWindow.document.write(
                '    #Vitals_print_table_tbody tbody tr:nth-child(odd) {',
            )
            printWindow.document.write('        background-color: #f2f2f2;')
            printWindow.document.write('    }')
            printWindow.document.write(
                '    #Vitals_print_table_tbody tbody tr:nth-child(even) {',
            )
            printWindow.document.write('        background-color: #e6e6e6;')
            printWindow.document.write('    }')
            printWindow.document.write('</style>')
            printWindow.document.write('</head><body>')
            printWindow.document.write(divContent)
            printWindow.document.write('</body><html>')
            printWindow.document.close()
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        } else {
            console.error('Failed to open print window.')
        }
    }





    // Reset all selections
    resetSelection(): void {
        this.clinical = ''; // Clear the selection
        console.log('All selections have been reset');
        this.displaychartstypepopup = false;
    }


    //getBMIStyle(bmi: number): any {
    //    if (bmi == null || isNaN(bmi)) {
    //        return { color: 'gray !important' };
    //    }

    //    if (bmi < 18.5) {
    //        return { color: 'blue !important' }; // Underweight
    //    } else if (bmi >= 18.5 && bmi <= 24.9) {
    //        return { color: 'green !important' }; // Normal weight
    //    } else if (bmi >= 25.0 && bmi <= 29.9) {
    //        return { color: 'orange !important' }; // Overweight
    //    } else if (bmi >= 30.0) {
    //        return { color: 'red !important' }; // Obese
    //    }

    //    return {
    //        color: 'black !important' };
    //}

    getBMIClass(bmi: number): string {
        // alert(bmi);

        if (bmi == null || isNaN(bmi) || bmi == 0) {
            return 'p-badge-secondary'; // Gray
        }

        if (bmi < 18.5) {
            return 'p-badge-info'; // Blue - Underweight
        } else if (bmi <= 24.9) {
            return 'p-badge-success'; // Green - Normal
        } else if (bmi <= 29.9) {
            return 'p-badge-warning'; // Yellow - Overweight
        } else {
            return 'p-badge-danger'; // Red - Obese
        }
    }


    getBMIStyle(bmi: number): any {
        if (bmi == null || isNaN(bmi) || bmi == 0) {
            return { color: 'gray', fontWeight: 'bold' };
        }

        if (bmi < 18.5) {
            return { color: 'blue', fontWeight: 'bold' }; // Underweight
        } else if (bmi <= 24.9) {
            return { color: 'green', fontWeight: 'bold' }; // Normal
        } else if (bmi <= 29.9) {
            return { color: 'orange', fontWeight: 'bold' }; // Overweight
        } else {
            return { color: 'red', fontWeight: 'bold' }; // Obese
        }
    }

}
